import { Injectable } from '@angular/core'
import { Logger } from '../../../logger.service'
import { ApiService } from '../../general/api.service'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { Vendor } from '../../../models'
import { HttpParams } from '@angular/common/http'
import { LocalStorageService } from '@hmp/helper'

const log = new Logger('VendorService')

/**
 * Đây là services dành cho VendorService
 */
@Injectable({ providedIn: 'root' })
export class VendorService {
  constructor(
    private apiService: ApiService,
    private storage: LocalStorageService
  ) {}
  /**
   * Khai báo tất cả các path sẻ sử dụng
   */
  private _apiPath = {
    list: 'vendor/vendor_entity',
    detail: 'vendor/vendor_entity',
  }

  /**
   * Lấy tất cả vendor
   */
  getAll(params?: any): Observable<any> {
    let pa = new HttpParams().set(
      'parameters[vendor_business_id]',
      this.storage.getActiveLocalBusinessID()
    )
    if (params) {
      Object.keys(params).forEach(function(key) {
        pa = pa.append(key, params[key])
      })
    }

    return this.apiService.get<any>(this._apiPath.list, pa).pipe(
      map(data => {
        if(data == undefined) {
          return []
        }
        return data
      })
    )
  }

  /**
   * Lấy thông tin chi tiết của Vendor dưạ vào @id
   * @param Id ID của Vendor
   */
  getDetail(id: string): Observable<Vendor> {
    return this.apiService.get<Vendor>(`${this._apiPath.detail}/${id}`).pipe(
      map(data => {
        log.debug(data)
        return data
      })
    )
  }

  /**
   * Tạo Vendor
   * @param res Thông tin Vendor
   */
  create(res: Vendor): Observable<any> {
    res.vid = null
    return this.apiService.post(this._apiPath.detail, res).pipe(
      map(data => {
        log.debug(data)
        return
      })
    )
  }

  /**
   * Chỉnh sửa thông tin Vendor
   *
   * @param res Thông tin Vendor muốn chỉnh sửa
   */
  edit(res: Vendor): Observable<any> {
    return this.apiService.put(`${this._apiPath.detail}/${res.vid}`, res).pipe(
      map(data => {
        return data
      })
    )
  }

  /**
   * Xóa thông tin Vendor
   *
   * @param id Xóa Vendor bằng Vendor ID
   */
  delete(id): Observable<any> {
    return this.apiService.delete(`${this._apiPath.detail}/${id}`).pipe(
      map(data => {
        log.debug(data)
        return data
      })
    )
  }
}
